var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.0714,
    cy: 80,
    rx: 56.5714,
    ry: 56,
    fill: "#FFEBF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.066 28.7834C66.0575 28.7834 69.297 25.5439 69.297 21.5523C69.297 17.5608 66.0575 14.3213 62.066 14.3213C58.0745 14.3213 54.835 17.5608 54.835 21.5523C54.835 25.5439 58.0745 28.7834 62.066 28.7834Z",
    fill: "#005CA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0514 31.8116C90.0514 36.547 86.2126 40.3859 81.4771 40.3859C76.7417 40.3859 72.9028 36.547 72.9028 31.8116C72.9028 27.0761 76.7417 23.2373 81.4771 23.2373C86.2126 23.2373 90.0514 27.0761 90.0514 31.8116Z",
    stroke: "#F0C1D9",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3002 49.2387C74.3002 52.4712 71.6797 55.0917 68.4472 55.0917C65.2147 55.0917 62.5942 52.4712 62.5942 49.2387C62.5942 46.0062 65.2147 43.3857 68.4472 43.3857C71.6797 43.3857 74.3002 46.0062 74.3002 49.2387Z",
    stroke: "#F0C1D9",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.99 49.1431L81.7356 103.397L55.3569 77.0184",
    stroke: "#00457A",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.5286ea25efbcaa70ef52d223457eabd1.svg";
export { ForwardRef as ReactComponent };